export default {
  ACTION_NEEDED: {
    value: 'ACTION NEEDED',
    background: 'j'
  },
  ACTION_NEEDED_CONFIRM: {
    value: 'ACTION NEEDED',
    background: 'j'
  },
  ACTION_NEEDED_VERIFY: {
    value: 'ACTION NEEDED',
    background: 'j'
  },
  DECLINED: {
    value: 'DECLINED',
    background: 'b',
    style: {
      opacity: 0.35
    }
  },
  REQUESTED: {
    value: 'REQUESTED BOOKING',
    background: 'b3'
  },
  CONFIRMED: {
    value: 'CONFIRMED BOOKING',
    background: 'c'
  },
  DRAFT: {
    value: 'DRAFT',
    background: 'b',
    style: {
      opacity: 0.35
    }
  },
  COMPLETED: {
    value: 'COMPLETED',
    background: 'b'
  },
  PENDING_FOR_MODERATION: {
    value: 'PENDING FOR MODERATION',
    background: 'd'
  },
  FEATURED: {
    value: 'FEATURED',
    background: 'h'
  },
  RECOMMENDED: {
    value: 'RECOMMENDED',
    background: 'b2'
  },
  PENDING: {
    value: 'PENDING',
    background: 'a'
  },
  UPDATE_MEETING_DATE: {
    value: 'PLEASE UPDATE THE MEETING DATE',
    background: 'j'
  },
  APPROVED: {
    value: 'APPROVED',
    background: 'c2'
  },
  PAID: {
    value: 'PAID',
    background: 'c'
  },
  PAYMENT_FAILED: {
    value: 'PAYMENT FAILED',
    background: 'j'
  }
}
